import { AIInsightsSheet } from '@/components/AIAssistant/AIInsightsSheet';
import { aiService } from '@/services/aiService';
import type { PersonalInsight } from '@/services/aiService';
import type { Anomaly } from '@/types/anomaly';
import type { PolicyViolation } from '@/data/mockPolicyViolations';
import type { Timesheet } from '@/types/timesheet';
import type { MinSeverity } from '@/utils/ApprovalDashboard/issueWarnings';
import { buildIssueWarnings } from '@/utils/ApprovalDashboard/issueWarnings';

export interface IssuesSheetProps {
  timesheet: Timesheet;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Violations the current user is permitted to see. */
  violations: PolicyViolation[];
  /** Anomalies the current user is permitted to see. */
  anomalies: Anomaly[];
  minSeverity: MinSeverity;
  overtimeEnabled: boolean;
}

export function IssuesSheet({
  timesheet,
  open,
  onOpenChange,
  violations,
  anomalies,
  minSeverity,
  overtimeEnabled,
}: IssuesSheetProps) {
  const filteredWarnings = buildIssueWarnings(violations, anomalies, minSeverity);

  // Overtime summary — only when overtime tracking is enabled for this org
  const overtimeInsight: PersonalInsight | null = overtimeEnabled
    ? aiService.generateOvertimeInsight(timesheet)
    : null;

  return (
    <AIInsightsSheet
      open={open}
      onOpenChange={onOpenChange}
      warnings={filteredWarnings}
      overtimeInsight={overtimeInsight}
    />
  );
}
